export default "__VITE_ASSET__BPc$YRt4__"